// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"87eb1b3a","224":"6bf0c3e0","250":"2a1dbf09","407":"d7065508","436":"44ae0912","453":"f394a27d","455":"2b9dbaca","501":"3990975d","595":"2019cdd0","606":"82e0fe0b","691":"c6c857b0","821":"a3059a74","925":"3044f264","969":"f13d7445"}[chunkId] + ".chunk.js";
};